import { push } from 'react-router-redux';
import WorkOrdersApi from '../../../../services/api/work-orders-api';
import {
  baseRoutePath,
  loadWorkOrderSummarySuccess,
  removeTask,
  removeTaskFromSummary,
  updateWorkOrder,
} from '../work-orders';
import {
  WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS,
  WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS,
  WORK_ORDERS_CREATION_SUMMARY_START,
} from '../action-types';
import { showErrorMessage } from '../../../messages';
import { tasksApi } from '../../../../services/api/tasks-api';

export function deleteTaskRequest(id) {
  return (dispatch) => {
    return tasksApi.removeTask(id).then((response) => {
      if (response.ok) {
        dispatch(removeTask(id));
        dispatch(removeTaskFromSummary(id));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadWorkOrderSummaryRequest(workOrderId) {
  return (dispatch) => {
    dispatch(workOrderSummaryStart());
    return WorkOrdersApi.getSummary(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(loadWorkOrderSummarySuccess(response.summary));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function workOrderSummaryStart() {
  return {
    type: WORK_ORDERS_CREATION_SUMMARY_START,
  };
}

export function workOrderConfirmationRequest(workOrderId) {
  return (dispatch) => {
    return WorkOrdersApi.confirmWorkOrder(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(workOrderConfirmationSuccess());
        dispatch(updateWorkOrder(response.workOrder));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function workOrderConfirmationSuccess() {
  return {
    type: WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_SUCCESS,
  };
}

export function workOrderConfirmationWithoutPicturesRequest(workOrderId) {
  return (dispatch) => {
    return WorkOrdersApi.requestSubmit(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(workOrderConfirmationWithoutPicturesSuccess());
        dispatch(updateWorkOrder(response.workOrder));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function workOrderConfirmationWithoutPicturesSuccess() {
  return {
    type: WORK_ORDERS_CREATION_SUMMARY_CONFIRMATION_WITHOUT_PICS_SUCCESS,
  };
}

export function finishWorkOrderCreation() {
  return (dispatch) => {
    dispatch(push(baseRoutePath));
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/creation/work-order-summary.js